import LoginForm from "components/users/LoginForm";

export default function Login() {
    return <LoginForm />;
}
